import React, { useEffect, useState, useMemo } from 'react';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';


export default function EthnicitySegmentControl({activeRaceTab, raceTabs, onRaceClick}) {

  // Button width in px, should match container width / options.length
  const width = 320;
const segmentWidth = useMemo(() => width / raceTabs.length, [raceTabs.length]);




  return (
    <div style={{
            width: "100dvw",
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: '10px'

            }}>
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        width: `${width}px`,
        background: '#E0E0E0',
        borderRadius: '20px',
        padding: '4px',
        boxSizing: 'border-box',
        height: '42px',
        alignItems: 'center',
      }}
    >
      {/* Highlight/Slider */}
      <Box
        sx={{
          position: 'absolute',
          top: 5,
          left: 4 + activeRaceTab * segmentWidth,
          width: segmentWidth - 8,
          height: '32px',
          background: raceTabs[activeRaceTab].color,
          borderRadius: '16px',
          boxShadow: '0 4px 16px 0 rgba(0,0,0,0.10), 0 1.5px 6px 0 rgba(0,0,0,0.07)',
          transition: 'left 0.25s cubic-bezier(.4,1.2,.7,1), background 0.2s, box-shadow 0.2s',
          zIndex: 1,
        }}
      />
      {raceTabs.map((tab, idx) => (
        <ButtonBase
          key={tab.label}
          onClick={() => onRaceClick(tab.value)}
          disableRipple
          sx={{
            flex: 1,
            height: 40,
            zIndex: 2,
            position: 'relative',
            fontWeight: activeRaceTab === tab.value ? 700 : 500,
            color: '#222',
            fontSize: '1.1rem',
            borderRadius: '8px',
            background: 'transparent',
            transition: 'color 0.2s, font-weight 0.2s, background 0.2s',
          }}
        >
          {tab.label}
        </ButtonBase>
      ))}
    </Box>
        <p style={{fontSize:"12px", fontWeight:"400", color:"#9e9e9e", paddingTop:"3px", paddingBottom:'5px'}}>Choose desired level of specificity</p>
    </div>
  );
}